<template>
    <div class="list-box">
        <div class="list-header HeaderBar Headerbg" :class='{active:active,scrool:scrool}'>
            <div class="list-header-main" @click="changeSidebar()">
                <i v-show="!main" class="iconfont x-a-maenbtn"></i>
                <i v-show="main" class="iconfont x-a-maenbtnx"></i>
            </div>
            <div class="list-header-logo">
                <img v-show="zhactive" @click="changeIndex()"  src="@/assets/images/index-svg-black.svg" alt="">
                <img v-show="enactive" @click="changeIndex()"  src="@/assets/images/index-svg-black-en.svg" alt="">
            </div>
            <div class="list-header-En">
                <span  v-show="skill" @click="changeSore()">{{$t('lang.list_header')}}</span>
                <span class="spancolor" :class='{spanactive:zhactive}' @click="setLanguage('zh')">中文</span>
                <span> <el-divider direction="vertical"></el-divider></span>
                <span class="spancolor" :class='{spanactive:enactive}' @click="setLanguage('en')">EN</span>
            </div>
        </div>
        <!-- 小屏状态 -->
        <div class="list-aside AsideBar" :class="{AsideBaractive:mianOpen}">
            <div class="HeaderI"></div>
            <div class="Sider">
                <ul class="Sider-ul">
                    <li class="Sider-ul-li" v-for="(item,i) in list" :key='i' :class="{active:item.active}"  @click="tochangeli(item)">
                        <span class="spanul">{{$t(item.name)}}</span> &nbsp;<span class="spanul2" v-show="i ==1"></span>
                        <ul :class='{active:item.show===true}'  :ref="`list${i}`">
                            <li v-for="(a,index) in item.list" :class="{active:listLiAllidx == a.id }" :key="index" @click.stop="doThis(a)">
                                <span v-show="zhactive" class="spanli">{{a.name}}</span>
                                <span v-show="enactive" class="spanli">{{a.name_en}}</span>
                            </li>
                        </ul>
                    </li>
                </ul> 
            </div>
            <div class="AsideBar-bottom">      
                <span class="spancolor" :class='{spanactive:zhactive}' @click="setLanguage('zh')">中文</span>
                <span class="spancolor" :class='{spanactive:enactive}' @click="setLanguage('en')">EN</span>
            </div>
        </div>
        <!-- 大屏 -->
        <div class="Center">
            <div class="HeaderI"></div>
            <div class="list-box">
                <div class="list-box-left" :class="[{'MiansmallOpenctive':miansmallOpen},{'derailcenterleft':derailcenterleft}]">
                    <div class="HeaderI"></div>
                    <div class="Sider">
                        <ul class="Sider-ul">
                            <li class="Sider-ul-li" v-for="(item,i) in list" :key='i' :class="{active:item.active}"  @click="tochangeli(item)">
                                <span class="spanul">{{$t(item.name)}}</span>
                                <ul :class='{active:item.show===true}'  :ref="`listlg${i}`">
                                    <li v-for="(a,index) in item.list" :class="{active:listLiAllidx == a.id }" :key="index" @click.stop="doThis(a)">
                                        <span v-show="zhactive" class="spanli">{{a.name}}</span>
                                        <span v-show="enactive" class="spanli">{{a.name_en}}</span>
                                    </li>
                                </ul>
                            </li>
                        </ul> 
                    </div>
                </div>
                <div class="list-box-right" :class="{MiansmallOpenctive:miansmallOpen}">
                    <div class="list-center">
                        <div class="HeaderI"></div>
                        <!-- 开始 -->
                        <div class="list-swiper-box">
                            <swiper class="list-swiper" :options="swiperOptions">
                                <swiper-slide class="list-swiper-slide" v-for="(item,i) in headerlist" :key="i">
                                    <div class="list-img-box">
                                        <img style="" :src="item"/>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="list-common-box">
                            <div class="list-center-box list-width">
                                <div  v-html="description">
                                </div>
                                <div>
                                    <ul class="list-center-box-ul2">
                                        <li>{{modelstyle}}</li>
                                        <li>{{$t('lang.RMB')}} {{price == 0 ?"-":price}}</li>
                                        <li>
                                            <span v-show="freight>0">{{$t('lang.list_Freight')}}{{freight}}</span>
                                            <span v-show="freight == 0">{{$t('lang.list_Freight1')}}</span>
                                        </li>
                                        <li class="list-center-box-ul-li-span">
                                            <a :href="shopurl" target="_blank">{{$t('lang.Product_Buy_now')}}</a>
                                            <span></span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div  v-show="videoList.length != 0"  class="video-list" v-for="(item,i) in videoList" :key="i">
                            <div class="video-list-box">
                                <div class="video_list_box_i1"><i @click="changesound(i)" class="iconfont x-kaiqiyinliang" :class="item.issound?'x-kaiqiyinliang':'x-guanbiyinliang'"></i></div>
                                <div class="video_list_box_i2"><i @click="changeplay(i)" class="iconfont x-kaiqiyinliang" :class="item.isplay?'x-pause':'x-play'"></i></div>
                                <video :class="item.issound?'':''"
                                    :ref="`video${i}`"
                                    muted
                                    autoplay  loop preload="auto" 
                                    webkit-playsinline='true'
                                    playsinline="true"
                                    x5-playsinline="true"
                                    x-webkit-airplay="true"
                                    x5-video-player-type="h5"
                                    x5-video-player-fullscreen="true" 
                                    x5-video-ignore-metadata="true"
                                    x5-video-orientation="landscape"
                                    :src="languageType == 'zh'?item.video:item.video_en" type='video/mp4; codecs="avc1.4D401E, mp4a.40.2"'></video>
                            </div>
                        </div>
                          
                        <div class="list-common-box list-common-box-list" v-show="imglist">
                            <div :class="listImg ? 'list-img-center' :'list-img-center-active'" v-for="(item,i) in imglist" :key="i">
                                <div v-show="zhactive" class="list-imgcenter-box">
                                    <img :src="item.image" alt="">
                                    <div class="list-imgcenter-text">
                                        <div class="list-width-imgcenter" v-html="item.description">
                                            <!-- <p :class="{pColor:item.p}">{{item.description}}</p> -->
                                        </div>
                                    </div>
                                </div>
                                <div v-show="enactive" class="list-imgcenter-box">
                                     <img :src="item.image_en" alt="">
                                    <div class="list-imgcenter-text">
                                        <div class="list-width-imgcenter" v-html="item.description_en">
                                            <!-- <p :class="{pColor:item.p}">{{item.description_en}}</p> -->
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            
                        </div>

                        <!-- content部分 -->
                        <div class="list-common-content">
                            <div class="list-width-content">
                                <div v-html="languageType == 'zh'?content:content_en"></div>
                            </div>
                           
                        </div>
                        <!-- 结束 -->
                           
                      
                    </div>
                    <div class="common-width">
                       <div class="Bottom">
                           <div class="Bottom-list">
                                <div  v-for="(item,i) in icons" :key="i" @click="iconto(i)" @mouseenter="mouseEnter(i)" @mouseleave="mouseLeave(i)">
                                    <a href="javascript:;">
                                        <i class="derail-center-right-mean-i" :class="'iconfont'+ ` ${item}`">
                                            <div class="box-Bottom" :class="{bottomLi:i == idxi && i==0}" >
                                                <div class="Triangle-down"></div>
                                                  <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
                                                    <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
                                            </div>
                                        </i>
                                    </a>
                                </div>
                                 <!-- <share :config='config'></share> -->
                           </div>
                           <div class="Bottom-divider">
                                <el-divider></el-divider>
                           </div>
                           <div class="Bottom-icp">
                                <div><a href="javascript:;">{{$t('lang.Record_1')}}</a></div>
                                <div>&nbsp;&nbsp;&nbsp;</div>
                                <div><a href="https://beian.miit.gov.cn" target="_blank">{{$t('lang.Record_2')}}</a></div>
                           </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="BottomLeft">
            <div class="BottomLeft-box">
                <div class="BottomLeft-list">
                    <div  v-for="(item,i) in icons" :key="i" @click="iconto(i)" @mouseenter="mouseEnter(i)" @mouseleave="mouseLeave(i)">
                        <a href="javascript:;">
                            <i class="derail-center-right-mean-i" :class="'iconfont'+ ` ${item}`">
                                <div class="box-Bottom" :class="{bottomLi:i == idxi && i==0}" >
                                    <div class="Triangle-down"></div>
                                        <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
                                        <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
                                </div>
                            </i>
                        </a>
                    </div>
                     <!-- <share :config='config'></share> -->
                </div>
                <div class="BottomLeft-icp">
                    <div><a href="javascript:;">{{$t('lang.Record_1')}}</a></div>
                    <div>&nbsp;&nbsp;&nbsp;</div>
                    <div><a href="https://beian.miit.gov.cn" target="_blank">{{$t('lang.Record_2')}}</a></div>
                </div>
            </div>
        </div>
        <div class="listHeaderSoreDetailZindex" :class="{listHeaderSoreDetail:sore}">
            <div  class="list-width">
                <div class="list-sore">
                    <div class="list-sore-header list-between">
                        <div class="list-sore-title">{{$t('lang.list_header')}}</div>
                        <div @click="changeSore()"><i class="iconfont x-a-maenbtnx"></i></div>
                    </div>
                    <div>
                        <el-collapse v-model="activeName" accordion>
                            <el-collapse-item v-for="(item,i) in siderlist" :key='i' :title="item.name" :name="i">
                              <div v-html="item.list"></div>
                              <!-- <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
                              <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div> -->
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
            </div>
        </div>
        <div class="all-center" :class="{openicon:openicon}">
            <div class="all-center-box" @click="changeiconto"></div>
            <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
            <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide} from 'vue-awesome-swiper'
//更新太多，代码赘余了，下一个程序员可以维护一下  (~_~)
import { product,Lists,faqsList } from "@/api/index";
// 后台端两个获取数据接口，一个获取详情列表product，一个获取列表数据的详情Lists
import {priceTo,Localurl} from "@/utils/validate"
import 'swiper/css/swiper.css'
import {mapGetters} from "vuex"
export default {
    name:'index',
    components:{
        Swiper,SwiperSlide
    },
    computed:{
        ...mapGetters(["languageType","shopId"])
    },
    data(){
        return{
            content:'',
            content_en:'',
            idxi:-1,
            swiperOptions:{
                spaceBetween : 20,
                slidesPerView : 'auto', 
                slidesOffsetAfter : 100,
            },
            derailcenterleft:false,
            activeName:0,
            sore:false,
            zhactive:true,
            enactive:false,
            main:false,
            mianOpen:false,
            miansmallOpen:false,
            active:false,
            skill:true,
            headerbarlistactive:true,
            listcenter:false,
            openicon:false,
            listImg:true,
            scrool:false,
            icons:['x-wechat','x-jd','x-tm'],
            list:[ 
                {name:'lang.index_li1',url:{name:'/detail',open:true},list:[],show:false,active:false},
                {name:'lang.index_li2',url:{name:'/list',open:false},list:[],show:false,active:true},
                {name:'lang.index_li3',url:{name:'/about',open:true},list:[],show:false,active:false},
                {name:'lang.index_li4',url:{name:'/position',open:true},list:[],show:false,active:false},
                {name:'lang.index_li5',url:{name:'/callus',open:true},list:[],show:false,active:false},
            ],
            
            imglist:[
                {title:'勇气',p:false,text:'我们相信窗户，而不是墙壁。 我们为CT-1 提供了透明贴面，以突出和庆祝下面的工艺，并揭示我们技术的原始美。',url:require('../../assets/images/big1.jpg')},
                {title:'勇气',p:true,text:'我们相信窗户，而不是墙壁。 我们为CT-1 提供了透明贴面，以突出和庆祝下面的工艺，并揭示我们技术的原始美。',url:require('../../assets/images/big2.jpg')},
                {title:'勇气',p:true,text:'我们相信窗户，而不是墙壁。 我们为CT-1 提供了透明贴面，以突出和庆祝下面的工艺，并揭示我们技术的原始美。',url:require('../../assets/images/big2.jpg')}
            ],
            detaildata:[],
            reqListdata:[],
            siderlist:[],//页面内容
            mainliHeight:50,
            config:{
                sites:['qq','wechat','linkedin','facebook','twitter'],
            },
            detailList:[],
            headerlist:[],
            videoList:[],
            modelstyle:'',
            price:'',
            freight:'',
            shopurl:'',
            description:'',
            listLiAll:false,
            listLiAllidx:0,
            number:'',
            // issound:true,
            // isplay:true,
        }
    },
    mounted(){
        // console.log(this.number)
        // console.log(this.list[1].list)
        // console.log(this.list[1].list.length)
        // this.$nextTick(()=>{
            // console.log(this.list[1].list.length)
        // })
        setTimeout(()=>{
            this.active=true
            this.getWidth();
            this.openicon=false;
            this.setLanguage(this.languageType)
            if(this.shopId != undefined){
                Localurl("?lang="+this.languageType+'&id='+this.shopId);
            }
            // this.$refs[`list${3}`][0].style.height =this.list[3].list.length * this.mainliHeight+30 +'px';
            // this.$refs[`listlg${3}`][0].style.height =this.list[3].list.length * this.mainliHeight+30 +'px';
           
            // var a = JSON.parse(JSON.stringify(this.list[1].list))
            // this.$refs[`list${1}`][0].style.height =this.list[1].list.length * this.mainliHeight+30 +'px';
            // this.$refs[`listlg${1}`][0].style.height =this.list[1].list.length * this.mainliHeight+30 +'px';
        },500)
    },

    methods:{
        changeSidebar(){
            if(!this.headerbarlistactive){
                this.main = !this.main
                this.mianOpen = !this.mianOpen
            }else{
                this.main = !this.main
                this.miansmallOpen = !this.miansmallOpen
            }
        },
        changeIndex(){this.$router.push({path:'/index',query:{lang:this.languageType}})},
        getWidth(){
            if( window.innerWidth < 992 && this.headerbarlistactive){
                this.headerbarlistactive = false
                this.listcenter= true
                this.miansmallOpen = false
                this.main=false
            }
            if( window.innerWidth >= 992 && !this.headerbarlistactive){
                this.headerbarlistactive = true
                this.listcenter= false
                this.main=false
                this.mianOpen=false
            }
            if( window.innerWidth >= 768 ){
                this.listImg=true
            }else{
                this.listImg=false
            }
            if( window.innerWidth >= 468 && !this.headerbarlistactive){
                this.openicon=false
            }
        },
        tochangeli(item){
            if(this.$route.path == item.url.name){return;}
            if(item.url.open){this.$router.push(item.url.name);}
            if(!item.url.open){this.$router.push({path:item.url.name,query:{id:item.list[0].id}});}
            // if(this.listLiAll){
            //     this.$refs[`list${i}`][0].style.height = '0'
            //     this.$refs[`listlg${i}`][0].style.height = '0'
            //     this.listLiAll = false
            // }else{
            //     this.list.map((i,mapidx)=>{
            //         if(item.show !== i.show){
            //             i.show = false 
            //             this.$refs[`list${mapidx}`][0].style.height = '0'
            //             this.$refs[`listlg${mapidx}`][0].style.height = '0'
            //         }
            //     })
            //     item.show = !item.show;
            //     this.$refs[`list${i}`][0].style.height =this.list[i].list.length * this.mainliHeight +'px';
            //     this.$refs[`listlg${i}`][0].style.height =this.list[i].list.length * this.mainliHeight +'px';
            //     this.listLiAll = true
            // }
        },
        doThis(item){
            if(item.open){this.$router.push({path:item.namelink,query:{key:'key',id:item.id}});return;}
            this.detail(item.id);
            this.reqLists(item.id);//技术参数//获取详情
            this.listLiAllidx = item.id;//选中样式
        },
        changeSore(){
            this.sore =!this.sore
        },
        setLanguage(val){
            this.$i18n.locale = val
            this.$store.dispatch("index/language",{lang:val})
            Localurl("?lang="+this.languageType+'&id='+this.shopId);
            this.siderlist =[]
            if(val == 'zh'){
                this.zhactive = true
                this.enactive = false
                this.headerlist =this.detailList.imagesI
                this.modelstyle =this.detailList.modelstyle
                document.title = this.detailList.name
                this.price =this.detailList.price
                this.freight=this.detailList.freight
                this.shopurl =  this.detailList.shopurl
                this.description = this.detailList.description
                
                for(var i = 0;i<this.reqListdata.length;i++){
                    this.siderlist.push({
                        name:this.reqListdata[i].title,
                        list:this.reqListdata[i].content
                    })
                }
            }else{
                this.enactive = true
                this.zhactive = false
                this.headerlist =this.detailList.imagesI_en
                this.modelstyle =this.detailList.modelstyle_en
                this.price =this.detailList.price_en
                this.freight=this.detailList.freight_en
                document.title = this.detailList.name_en
                this.shopurl =  this.detailList.shopurl_en
                this.description = this.detailList.description_en
                for(var j = 0;j<this.reqListdata.length;j++){
                    this.siderlist.push({
                        name:this.reqListdata[j].title_en,
                        list:this.reqListdata[j].content_en
                    })
                }
            }
        },
        mouseEnter(i) {this.idxi =i},
        mouseLeave() {this.idxi =-1},
        handleScroll(){
            if(window.pageYOffset>20){
                this.derailcenterleft =true
                this.scrool=true
              
            }else{
                this.derailcenterleft =false
                this.scrool=false
            }
        },
        iconto(i){
            if(i===0 && !this.headerbarlistactive){this.openicon=true}
            if(i===1){window.open("https://mall.jd.com/index-12191261.html","_black")}
            if(i===2){window.open("https://x-speaker.tmall.com/?spm=a217wi.openworkbeanchtmall.widgets.2.41e65e16MbeHsw","_black")}
        },
        changeiconto(){this.openicon=false},
        fetchData(){
            // 产品列表
            product({pageSize:20}).then((res) => {
                if(res.code == 200){
                    
                    var data = res.data.list;
                    this.detaildata = data;
                    var detaildataId = [];
                    for(var i=0;i<data.length;i++){
                        this.list[1].list.push({
                            name:data[i].name,
                            name_en:data[i].name_en,
                            id:data[i].id,
                            namelink:'/list',
                            open:false,
                        })
                        detaildataId.push(data[i].id)
                    }
                    this.$refs[`list${1}`][0].style.height =data.length * this.mainliHeight+30 +'px';
                    this.$refs[`listlg${1}`][0].style.height =data.length * this.mainliHeight+30 +'px';
                    this.setLanguage(this.languageType)
                    var s = detaildataId.includes(parseInt(this.$route.query.id));
                    
                    if(this.$route.query.id == undefined){
                        this.detail(this.detaildata[0].id)
                        return;
                    }
                    if(s){
                        this.detail(this.$route.query.id);
                        this.reqLists(this.$route.query.id)
                        this.listLiAllidx =this.$route.query.id 
                    }else{
                        var msg = this.languageType == 'zh'?"该产品已下架或不存在。":"The product has been taken off the shelf or does not exist."
                        this.$router.push({name:'404',params:{id:msg}})
                        return;
                    }
                    
                   

                    
            
                    
                   
                }
                
            });
            faqsList().then((res)=>{
                var data =res.data.list;
                for(var i=0;i<data.length;i++){
                    this.list[3].list.push({
                       name:data[i].name,
                       name_en:data[i].name_en,
                       id:data[i].id,
                       namelink:'/position',
                       open:true,
                    })
                }
            })
        },
        // 商品详情
        reqLists(sqlId){
            this.reqListdata=[];
            if(sqlId == undefined){return}
            Lists(sqlId).then((res) => {
                if(res.code == 200){
                    // 技术规格参数
                    var data = res.data.specs;
                    for(var j=0;j<data.length;j++){
                        for(var k=j;k<data.length;k++){
                            if(data[j].sort<data[k].sort){
                                var n = data[j];
                                    data[j] = data[k];
                                    data[k] =n
                            }
                        }
                    }
                    
                    for(var i=0;i<data.length;i++){
                        this.reqListdata.push({
                            title:data[i].title,
                            title_en:data[i].title_en,
                            content:data[i].content,
                            content_en:data[i].content_en
                        })
                    }
                    var listors = [];
                    for(var s=0;s<res.data.details.length;s++){
                        listors.push({
                            description: res.data.details[s].description,
                            description_en: res.data.details[s].description_en,
                            image: res.data.details[s].image,
                            image_en:res.data.details[s].image_en,
                        })
                    }
                    var videoList=[];
                    for(var y=0;y<res.data.videos.length;y++){
                        videoList.push({
                            description:res.data.videos[y].description,
                            description_en:res.data.videos[y].description_en,
                            product_id:res.data.videos[y].product_id,
                            sort:res.data.videos[y].sort,
                            video:res.data.videos[y].video,
                            video_en:res.data.videos[y].video_en,
                            issound:true,
                            isplay:true,
                        })
                    }
                    for(var q=0;q<videoList.length;q++){
                        for(var w=q;w<videoList.length;w++){
                            if(videoList[q].sort<videoList[w].sort){
                                var qw = videoList[q];
                                    videoList[q] = videoList[w];
                                    videoList[w] =qw
                            }
                        }
                    }
                    this.videoList =videoList;
                    this.imglist = listors;
                    this.content = res.data.content
                    this.content_en = res.data.content_en
                    this.setLanguage(this.languageType)   
                }
                
            });     
        },

         // 商品详情
        detail(a){
            Localurl("?lang="+this.languageType+'&id='+a);
            this.$store.dispatch("index/shopId",{id:a})
            var list =[];
            for(var i=0;i<this.detaildata.length;i++){
                if(a == this.detaildata[i].id){
                    list.push({
                        CreatedAt: this.detaildata[i].CreatedAt,
                        UpdatedAt: this.detaildata[i].UpdatedAt,
                        content: this.detaildata[i].content,
                        description: this.detaildata[i].description,
                        description_en: this.detaildata[i].description_en,
                        details: this.detaildata[i].details,
                        freight: priceTo(this.detaildata[i].freight),
                        freight_en: priceTo(this.detaildata[i].freight_en),
                        id: this.detaildata[i].id,
                        images: this.detaildata[i].images,
                        images_en: this.detaildata[i].images_en,
                        modelstyle: this.detaildata[i].modelstyle,
                        modelstyle_en: this.detaildata[i].modelstyle_en,
                        name: this.detaildata[i].name,
                        name_en: this.detaildata[i].name_en,
                        price:priceTo(this.detaildata[i].price),
                        price_en: priceTo(this.detaildata[i].price_en),
                        a: priceTo(this.detaildata[i].price),
                        shopurl: this.detaildata[i].shopurl,
                        shopurl_en: this.detaildata[i].shopurl_en,
                        sort: this.detaildata[i].sort,
                        imagesI:this.detaildata[i].images.split(","),
                        imagesI_en:this.detaildata[i].images_en.split(","),
                    })
                }          
            }
            
            this.detailList = list[0];
            this.setLanguage(this.languageType)            
        },
        changesound(i){
            if(this.$refs[`video${i}`][0].muted){
                this.$refs[`video${i}`][0].muted =false
                this.videoList[i].issound = false;
            }else if(!this.$refs[`video${i}`][0].muted){
                this.$refs[`video${i}`][0].muted =true
                this.videoList[i].issound = true;
            }
            
        },
        changeplay(i){
             if(this.$refs[`video${i}`][0].paused){
                this.$refs[`video${i}`][0].play()
                this.videoList[i].isplay = true;
            }else if(this.$refs[`video${i}`][0].play()){
                this.$refs[`video${i}`][0].pause()
                this.videoList[i].isplay= false;
            }
        },
        // 封装排序
    },
    created(){
        this.fetchData();
        document.addEventListener('scroll',this.handleScroll);
        window.addEventListener('resize', this.getWidth);
    },
    beforeDestroy(){
        document.removeEventListener('scroll',this.handleScroll);
        window.removeEventListener('resize', this.getWidth); 
    },
}
</script>
<style>
.list-box{
    position: relative;
}
.list-box-left{
    position: absolute;
    left: -300px;
    top: -100px;
    width: 300px;
    height: 100vh;
    transition: .3s ease-in-out;
}
.list-box-left.MiansmallOpenctive{
    left: -0;
}
.list-box-right{
    position: absolute;
    top: -100px;left: 0px;
    overflow: hidden;width: 100%;
    transition: .3s all ease-in-out;
}
.list-box-right.MiansmallOpenctive{
    position: absolute;
    left: 300px;
    width: calc(100% - 300px);
}
.list-header-En > span:nth-child(1){
    display: inline-block;
    line-height: 13px;
}
@media (max-width: 1200px){}
@media (max-width: 992px){

    .list-header-En span:nth-child(2),
    .list-header-En span:nth-child(3),
    .list-header-En span:nth-child(4){
        display: none
    }
    .list-header-En span:nth-child(1){font-size:14px;}
    .list-box-right{top: -80px;}
}
@media (max-width: 468px){
    .list-header-En span:nth-child(1){font-size:12px;}
    .list-box-right{top: -60px;}
    .list-header-En > span:nth-child(1){
        width: 50px;
    }
}

/* 右边开始 */
/* .list-swiper-box{margin-left: 30px;} */
.list-swiper-slide{
  max-width:800px;/*设为固定值*/
  width:auto;/*根据内容调整宽度*/
}
.list-img-box,
.list-img-box img{
    width: 800px;
    height: 800px;
    object-fit: contain;
}
@media (max-width:1200px){.list-img-box,.list-img-box img{width: 800px;height: 800px;}}
@media (max-width:1084px){.list-img-box,.list-img-box img{width: 680px;height: 680px;}}
@media (max-width:992px){.list-img-box,.list-img-box img{width: 580px;height: 580px;}}
@media (max-width:778px){.list-img-box,.list-img-box img{width: 480px;height: 480px;}}
@media (max-width:578px){.list-img-box,.list-img-box img{width: 380px;height: 380px;}}
@media (max-width:468px){.list-img-box,.list-img-box img{width: 320px;height: 320px;}}

/* 中间部分 */

.list-common-box{
    padding:  30px 30px 0px 30px;
}
.list-center-box{
    display: flex;
    justify-content: space-between;
    flex-direction: row;
}
.list-center-box div:nth-child(1) ul li{
    white-space: nowrap;
    overflow: hidden;
}
.list-center-box-ul2 li{
    text-align: right;
    position: relative;
    line-height: 25px;
    color: #333333;
}
.list-center-box-ul2 li:nth-child(1){font-size: 30px;margin-bottom: 15px;}
.list-center-box-ul2 li:nth-child(2){font-size: 16px; line-height: 15px;}
.list-center-box-ul2 li:nth-child(3){margin-bottom: 25px;}
.list-center-box-ul2 li:nth-child(4){width:240px;border:1px solid #333;line-height: 45px;cursor: pointer;}
.list-center-box-ul2 li:nth-child(4) a{color: #333;width: 100%; height: 100%;display: flex;justify-content: center;}
.list-center-box-ul2 li:nth-child(1)::before{content: '';position:absolute;bottom: 0;right: 0;width: 90px;height: 10px;background-color: #df4344;text-align: right;z-index: -1;}

.list-center-box-ul-li-span{position: relative;z-index: 10;border-radius: 3px;}
.list-center-box-ul-li-span span{position: absolute;top: 0;left: 0;z-index: -1;background-color: black;width: 0;height: 45px;transition: .3s ease-in-out;}
.list-center-box-ul-li-span:hover{box-shadow: 0 0 7px 3px #ccc}
.list-center-box-ul-li-span:hover a{color: white!important;}
.list-center-box-ul-li-span:hover span{width: 100%;}
@media (max-width: 678px) {
    .list-center-box div:nth-child(1) {margin-bottom: 25px;}
    .list-center-box{flex-direction: column;}
    .list-center-box-ul2 li{text-align: left;}
    .list-center-box-ul2 li:nth-child(1)::before{left: 0;}
    .list-center-box-ul2 li:nth-child(4){width: 100%;}
}
@media (max-width:468px){
    .list-center-box-ul2 li:nth-child(4){width: 100%;}
}
.list-img-center{
    /* height: 100vh; */
    width: 100%;
    margin-bottom:30px;
    transition: .3s ease-in-out;
}
.list-img-center .list-imgcenter-box{
    position: relative;
}
.list-img-center .list-imgcenter-box{display: flex;background-repeat: no-repeat;align-items: center;height: 100%;width: 100%;background-size: cover;position: relative;}
.list-img-center .list-imgcenter-box img{
        width: 100%;
    height: 100%;
    border-style: none;
    object-fit: cover;
}
.list-img-center .list-imgcenter-text{
    overflow: hidden;
    width: 100%;position: absolute;left: 0;top:10%;transition: .5s all ease-in-out;transition-delay: .3s;height: 100px;
}
@media (max-width:678px){
    .list-img-center{margin-bottom:0px;}
    .list-img-center .list-imgcenter-text{top:100%;margin: 20px 0;}
    
}
.list-img-center-active{
    padding-bottom:20px; 
}
.list-img-center-active .list-imgcenter-box img{
    width: 100%;
    height: 100%;
    border-style: none;
    object-fit: cover;
}
.list-img-center-active .list-imgcenter-text{
    overflow: hidden;
    width: 100%;
    padding: 10px 0;
}
/* .list-common-content{
    padding:0 30px 30px;
} */
.list-width-content{
    width: 1070px;
    margin: 0 auto;
}
.list-width-content img{
    width: 100%;
    height: 100%;
    vertical-align: middle;
    object-fit: cover;
}
.list-width-imgcenter{
    width: 1070px;
    margin: 0 auto;
     color: white;
}  

@media (max-width: 1412px){
    .list-width-imgcenter{
        width: 80%;
        margin: 0 auto;
        color: white;
    } 
    .list-width-content{
         width: 80%;
        margin: 0 auto;
    }
}
@media (max-width:768px){
    .list-width-content{
         width: 100%;
    }
    .list-width-imgcenter{width: 100%;} 
    .list-width-imgcenter span{color: #000 !important;} 
}
@media (max-width:678px){
    .list-img-center{margin-bottom:0px;}
    .list-img-center-active .list-imgcenter-text{margin: 0px 0;}
}



/* @media (max-width:1200px){.list-img-center{height: 100vh;}}
@media (max-width:1084px){.list-img-center{height: 75vh;}}
@media (max-width:992px){.list-img-center{height: 55vh;}}
@media (max-width:778px){.list-img-center{height: 45vh;}}
@media (max-width:578px){.list-img-center{height: 35vh;}}
@media (max-width:468px){.list-img-center{height: 25vh;}} */
.listHeaderSoreDetailZindex{position: fixed;height: 0%;width: 100%;overflow: hidden;background-color: white;top: -100%;left: 0;z-index: 100;transition: all .4s ease-in-out;}
.listHeaderSoreDetail{height: 100%;z-index: 1000;overflow-y: visible;top: 0;transition: all .7s ease-in-out;}
.list-sore{
    padding: 20px;
}
.list-sore-header{height: 80px;display: flex;align-items: center;justify-content: space-between;}
.list-box-left.derailcenterleft{width: 300px;display: flex;position: fixed;top: 100px;left: -300px;height: 100vh;transition: .3s all ease-in-out;}
.list-box-left.derailcenterleft.MiansmallOpenctive{width: 300px;display: flex;position: fixed;top: 100px;left: -0;height: 100vh;transition: .3s all ease-in-out;}
.pColor{
    color: white;
}
@media (max-width:678px){.pColor{color: #333;}}
.list-sore-title{
    font-size: 20px;
    font-weight: 700;
}
.list-common-box-list{
    width: 100%;
    margin: 0 auto;
}
@media (max-width: 1150px) {
    .list-common-box-list{
        width: 100%;
        margin: 0 auto;
    }
}
@media (max-width: 992px) {
   .list-common-box {
    padding: 30px 30px 30px 30px;
    }
}
.video-list{
    height: 100%;
    width: 100%;
    padding: 0;
    padding-top: 30px;
    /* display: flex; */
}
.video-list video{
    width: 100%;
    height: 100%;
    padding:0 30px;
    display: flex;
}
.video-list-box{
    position: relative;
}
.video_list_box_i1{
    position: absolute;
    bottom: 36px;
    z-index: 11;
    width: 46px;
    height: 46px;
    right: 126px;
    /* border: 1px solid red; */
    display:flex;
    justify-content:center;
    align-items:center;
}
.video_list_box_i2{
    position: absolute;
    bottom: 36px;
    right: 66px;
    z-index: 11;
    width: 46px;
    height: 46px;
    /* border: 1px solid red; */
    display:flex;
    justify-content:center;
    align-items:center;
}
.video_list_box_i1 i,.video_list_box_i2 i{
    font-size: 36px;
    cursor: pointer;
    color: rgba(255, 255, 255, .5)
}
@media (max-width:768px){
    .video_list_box_i1 i,.video_list_box_i2 i{
        font-size: 22px;
        cursor: pointer;
        color: rgba(255, 255, 255, .5)
    }
    .video_list_box_i1{
        right: 106px;
        width: 36px;
        height: 36px;
        bottom: 16px;
        right: 106px;
    
    }
    .video_list_box_i2{
        bottom: 16px;
        width: 36px;
        height: 36px;
        right: 66px;
    }
}
@media (max-width:448px){
    .video_list_box_i1 i,.video_list_box_i2 i{
        font-size: 22px;
        cursor: pointer;
        color: rgba(255, 255, 255, .5)
    }
    .video_list_box_i1{
        right: 66px;
        width: 36px;
        height: 36px;
        bottom: 0px;
    
    }
    .video_list_box_i2{
        right: 36px;
        bottom: 0px;
        width: 36px;
        height: 36px;
    }
}

</style>
